"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9463],{

/***/ 69463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionMasonryGallery": function() { return /* binding */ SectionMasonryGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55022);




const GalleryWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    position: "relative"
});
const GalleryContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    gap: 0,
    overflowX: "auto",
    overflowY: "hidden",
    scrollSnapType: "x mandatory",
    scrollPadding: 0,
    "&::-webkit-scrollbar": {
        display: "none"
    },
    "@lg": {
        display: "block",
        columnCount: 3,
        columnGap: "$20",
        overflowX: "visible",
        padding: "0 $30"
    }
});
const MediaWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "relative",
    aspectRatio: "0.8",
    minWidth: "100vw",
    scrollSnapAlign: "start",
    overflow: "hidden",
    "@lg": {
        aspectRatio: "1.33",
        minWidth: "auto",
        borderRadius: "$8",
        marginBottom: "$20",
        breakInside: "avoid",
        display: "inline-block",
        width: "100%"
    },
    variants: {
        tallDesktop: {
            true: {
                "@lg": {
                    aspectRatio: "0.8"
                }
            }
        }
    }
});
const Gradient = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "absolute",
    insetInline: 0,
    bottom: 0,
    left: 0,
    height: "160px",
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, $black_06 100%)",
    pointerEvents: "none",
    zIndex: "$content",
    "@lg": {
        display: "none"
    }
});
const IndicatorsContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    position: "absolute",
    bottom: "calc($20 + $24)",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "$24",
    zIndex: "$videoControls",
    "@lg": {
        display: "none"
    }
});
const Indicator = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("button", {
    width: "$12",
    height: "$12",
    borderRadius: "50%",
    backgroundColor: "$gray300",
    transition: "background-color 0.3s ease",
    border: "none",
    padding: 0,
    cursor: "pointer",
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    },
    variants: {
        active: {
            true: {
                backgroundColor: "$white"
            }
        }
    }
});
const SectionMasonryGallery = (param)=>{
    let { gallery , spacing , topBorder  } = param;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const scrollContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const container = scrollContainerRef.current;
        if (!container) return;
        const handleScroll = ()=>{
            const scrollLeft = container.scrollLeft;
            const itemWidth = container.clientWidth;
            const newIndex = Math.round(scrollLeft / itemWidth);
            setActiveIndex(newIndex);
        };
        container.addEventListener("scroll", handleScroll);
        return ()=>container.removeEventListener("scroll", handleScroll);
    }, []);
    const scrollToIndex = (index)=>{
        const container = scrollContainerRef.current;
        if (!container) return;
        const itemWidth = container.clientWidth;
        const scrollPosition = index * itemWidth;
        container.scrollTo({
            left: scrollPosition,
            behavior: "smooth"
        });
    };
    const handleIndicatorClick = (index)=>{
        setActiveIndex(index);
        scrollToIndex(index);
    };
    if (!gallery || gallery.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(GalleryWrapper, {
        type: spacing || "MEDIUM",
        topBorder: topBorder,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryContainer, {
                ref: scrollContainerRef,
                children: gallery.map((mediaItem, index)=>{
                    // 1st, 5th, 8th images (indices 0, 4, 7) have aspect ratio 0.8 on desktop
                    const isTallDesktop = index === 0 || index === 4 || index === 7;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrapper, {
                        tallDesktop: isTallDesktop,
                        children: (mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.mediaPayload) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                                    ...mediaItem,
                                    sizes: "(min-width: 1000px) 33vw, 100vw",
                                    layout: "fill",
                                    objectFit: "cover"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gradient, {})
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IndicatorsContainer, {
                children: gallery.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Indicator, {
                        active: index === activeIndex,
                        onClick: ()=>handleIndicatorClick(index)
                    }, index))
            })
        ]
    });
};


/***/ })

}]);